export default "/pt-usde.d3e1585f47d92a04eb0f7c36f4d7a4c7.svg";